<template lang="html">
  <transition name="move">
    <div class="confirm" v-show="showFlag">
      <div class="confirm-view">
        <!-- 标题 确认单据 -->
          <div class="confirmtet">
            <span>{{ $t("confirmorder") }}</span>
          </div>

          <!-- 滚动 -->
          <div class="confirmscrollbar">
          <el-scrollbar style="height:95%; width:90%;  margin: auto;">
                          <!-- :rules="rules"
                          ref="ruleForm"
                          //小号组件
                          size="mini" 
                          //标题宽度
                          label-width="80px"
                          //是否显示错误信息
                          :show-message="false"
                          //标题左右对齐
                          label-position="right"
                          //是否显示红心
                          hide-required-asterisk="false" -->

            <el-form :model="orderAddress" :rules="rules" ref="ruleForm" size="mini" :show-message="false" hide-required-asterisk>
              <!-- 付款方式 -->
              <!--  //label = 标题   //prop = 指定错误信息    -->
                <el-form-item :label="$t('paymode')" style="margin-top: 10px;">
                  <!-- //ruleForm.resource = 绑定数据 -->
                  <el-radio-group v-model="state.orders.payMode">
                    <!-- class = 改写组件默认CSS样式 -->
                    <el-radio-button :label="$tc('paymodearray',0)"  class="confirmitme"></el-radio-button>
                    <el-radio-button :label="$tc('paymodearray',1)"  class="confirmitme"></el-radio-button>
                    <el-radio-button :label="$tc('paymodearray',2)"  class="confirmitme" ></el-radio-button>
                  </el-radio-group>
                </el-form-item>

               <!-- 地址 -->
                <el-form-item label="" prop="resource" >
                  <div @click="handleChange()">
                  <el-container>
                     <el-aside width="90%">  
                        <el-row >
                            <el-col :span="23"><p>{{orderAddress.Street}} , {{orderAddress.City}} , {{orderAddress.Province}} , {{orderAddress.Zip}}</p></el-col>
                       </el-row>
                      <el-row >
                        <el-col :span="23"><p>{{orderAddress.CustomerName}}  {{orderAddress.LinkmanPhone}}</p></el-col>
                       </el-row>
                      </el-aside>
                      <el-main >
                        <i :class="[isRotate?'el-collapse-item__arrow el-icon-arrow-right':'el-collapse-item__arrow el-icon-arrow-right is-active']"></i>
                      </el-main>
                   </el-container>
                   </div>
                </el-form-item>

                <!-- 地址
                <el-form-item label="地址" prop="desc">
                     <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                </el-form-item> -->

              <!-- 备注 -->
               <el-form-item :label="$t('remark')"  prop="desc" class="mb-1">
                     <el-input type="textarea" style="resize:none;"  v-model="state.orders.remark"></el-input>
                </el-form-item>

              <!-- 运费 -->
              <el-form-item :label="$t('delivery')" class="mb-1">
                   <!-- <el-input v-model="ruleForm.name"></el-input> -->
                   <span>{{state.orders.deliveryPrice | numFilter}} €</span>
              </el-form-item>

                <!-- 金额 -->
              <el-form-item :label="$t('subtotal')" class="mb-1">
                <span> {{state.orders.totalPrice | numFilter}} €</span>
              </el-form-item>

              <!-- 总金额 -->
              <el-form-item :label="$t('total')" style="color: red; " class="mb-1">
                <span> {{(state.orders.deliveryPrice + state.orders.totalPrice)  | numFilter}} €</span>
              </el-form-item>

          </el-form>
          </el-scrollbar>
          </div>
          <!-- 提交按钮 -->
          <div class="confirmprimary" @click="submitForm('ruleForm')">
            <span class="pay">
                      <!-- 提交订单 -->
                      {{ $t("sumbitorder") }}
                    </span>
          </div>
                <div class="confirm-close" @click="hide">
                     <i class="icon-close"></i>
                </div>
          
      <transition name="el-zoom-in-bottom"> -->
        <div v-show="show2" class="transition-box">
                    <el-scrollbar style="height:95%; width:90%;  margin: auto;">
                 <div class="rating-wrapper">
                    <ul>
                       <!-- 点击传递index -->
                      <li class="rating-item" v-for="(item,index) in myaddresseditlist" @click="selectFood(index,item,$event)">
                          <div class="myaddresscontent">
                            <!-- 收货人 -->
                            <h1 class="name">{{ $t('name') }}:{{item.CustomerName}}  </h1> 
                            <div class="star-wrapper">
                                <span class="delivery" >{{item.Street}} , {{item.City}}</span>
                            </div>
                            <div class="star-wrapper">
                                <span class="delivery" >{{item.Province}} , {{item.Zip}}</span>
                            </div>
                            <div class="time">
                            <!-- 电话 -->
                            {{ $t('phone') }} : {{item.LinkmanPhone}}
                              </div>
                            <div class="defaultaddress">
                              <input class="checkbtn" type="radio" :value='index' v-model="state.defaultaddress" > 
                            </div>
                          </div>
                      </li>
                        <li class="rating-item" @click="addAddress($event)">
                          <div class="myaddresscontent">
                            <div class="add-address">
                              <i class="icon-add_circle" style="color: #00b43c;"></i>
                            </div>
                          </div>
                        </li>
                    </ul>
   
          </div> 
             </el-scrollbar>
          </div>
      </transition> 
      </div>
    </div>
</transition>
</template>

<script>

export default {
  props: {},
  data() {
    return {
      showFlag: false,
      state: this.$store.state,
      isRotate: true,
      orderAddress: {},
      myaddresseditlist: [],
      // 折叠属性默认标识
      activeNames: '1',
      show2: false,
      // 验证内容
      rules: {
        // //required = 失去焦点时间开关    message = 错误内容   trigger = 触发事件
        // name: [
        //     { required: true, message: '请输入活动名称', trigger: 'blur' },
        //     { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        // ],
        // resource: [
        //     { required: true, message: '请选择填写地址', trigger: 'change' }
        // ],
        // desc: [
        //     { required: true, message: '请选择填写地址', trigger: 'blur' },
        // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        // ]
      }
    }
  },
  methods: {
    // 折叠触发方法
    handleChange() {
      this.isRotate = !this.isRotate
      this.show2 = !this.show2
    },
    show() {
      if (this.$store.state.uuid !== null) {
        this.orderAddress = this.state.myinfo.addres[this.state.defaultaddress || 0]
        console.log(this.orderAddress)
        this.myaddresseditlist = this.state.myinfo.addres
      }
      this.showFlag = true
    },
    hide() {
      this.showFlag = false
    },
    isshow() {
      return this.showFlag
    },
    confirmclick() {
      this.showFlag = false
      this.$parent.pay()
    },
    submitForm(formName) {
      this.activeNames = '0'
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmclick()
          // alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    selectFood(index, data, e) {
      if (!event._constructed) {
        return
      }
      // this.myaddresseditobj = data
      // 改为点击传递index
      // <li class="rating-item" v-for="(item,index) in myaddresseditlist" @click="selectFood(index,item,$event)">
      // 地址详情页面拿index读取公共变量数组干活
      // 暂时还没空      TODO          this.$refs.myaddressedit.show(index)
    }
    // 重置验证 输入框内容
    // resetForm(formName) {
    //   this.$refs[formName].resetFields()
    // }
  },
  mounted() {

  },
  filters: {
    numFilter (value) {
      // cutOutNum(value)
      let realVal = ''
      if (!isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2)
      } else {
        realVal = '--'
      }
      return realVal
    }
  },
  created() {},
  updated() {},
  computed: {
  },
  watch: {
  }
}
</script>

<style     lang="scss">
@import '../../common/sass/mixin.scss';


.mb-1{
margin-bottom:7px  !important;  
}

.confirm-close {
  // background: green;
  width: 32px;
  height: 32px;
  // margin-top: -64px auto 0 auto;
  font-size: 32px;
  line-height: 32px;
  clear: both;
  top: 10px;
  right: 10px;
  position: absolute;
}

.confirm {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  font-size: 12px;
  width: 100%;
  background: rgba(7, 17, 27, 0.5);
  &.move-enter-active,&.move-leave-active {
    // 动画过程
    transition: all 0.5s;
    transform: translate3d(0, 0, 0);
  }
  &.move-enter,&.move-leave-to {
    // 动画初始态
    transform: translate3d(100%, 0, 0);
  }
.el-main{
padding: 0;
}

    //滚动层
    .confirm-view{
      position: absolute;
      left: 20px;
      top: 40px;
      bottom: 60px;
      right: 20px;
      padding: 100px,0 0 0;
      background: antiquewhite;
      border-radius: 10px;
      background-color: #fff;
      height: 500px;
      
       .transition-box {
            position: absolute;
            bottom: 0px;
            width: 100%;
            top: 255px;
            border-radius: 4px;
            background-color: #f1f1f1;
            color: #fff;
            box-sizing: border-box;
              .rating-wrapper {
              padding: 0 18px;
              .rating-item {
              padding: 18px 0;
              @include border-1px(rgba(7,17,27,0.1));
              .avatar {
              flex: 0 0 28px;
              width: 28px;
              height: 28px;
              margin-right: 12px;
              border-radius: 50%;
              overflow: hidden;
              img {
              width: 100%;
              }
              }
              .myaddresscontent {
              position: relative;
              flex: 1;
              .name {
              margin-bottom: 4px;
              line-height: 12px;
              font-size: 10px;
              color: rgb(7,17,27);
              }
              .star-wrapper {
              margin-bottom: 6px;
              font-size: 0;
              .star {
              display: inline-block;
              vertical-align: top;
              margin-right: 6px;
              }
              .delivery {
              display: inline-block;
              vertical-align: top;
              line-height: 12px;
              font-size: 10px;
              color: rgb(147,153,159);
              }
              }
              .text {
              margin-bottom: 8px;
              line-height: 18px;
              font-size: 12px;
              color: rgb(7,17,27);
              }
              .time {
              position: absolute;
              top: 0;
              right: 0;
              line-height: 12px;
              font-size: 10px;
              color: rgb(147,153,159);
              }
              .checkbtn {
              height: 16px;
              width: 16px;
              color: rgb(0, 180, 60);
              }
              .defaultaddress{
              position: absolute;
              top: 32px; 
              right:2px;
              line-height: 30px; 
              color: rgb(147,153,159);
              }
              .add-address {
              // width: 32px;
              // height: 32px;
              // line-height: 12px;
              // font-size: 10px;
              // clear: both;
              width: 32px;
              height: 32px;
              font-size: 32px;
              line-height: 32px;
              clear: both;
              right: 9px;
              margin: auto;
              }
              }
              }
              }
  }
      .el-textarea__inner{
         resize: none;
      }
           .el-select-dropdown__item{
        height: 80px;
      }

        //  地址
        .grid-content-item{

            border: 1px solid #ced4da;
            padding: 5px 5px 5px 0px;
            margin-top: 5px;
          .el-row {
            margin-bottom: 3px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .el-col {
            border-radius: 4px;
          }
          .grid-content {
            background: #d3dce6;
            border-radius: 4px;
            height: 20px;
            text-align: center;
            line-height: 20px;
          }
        }

 

           //标题
    .confirmtet{
      height: 40px;
      width: 100%;
      /* margin: auto; */
      text-align: center;
      line-height: 40px;
      font-size: 14;
      font-size: 25px;
      margin-top: 15px;
   
    }
    .confirmscrollbar{
      position: absolute;
      top: 50px;
      bottom: -5px;
      left: 0;
      right: -5px;
     //付款方式
      .confirmitme{
        // background-color: black;
        ///每个按钮的样式
        .el-radio-button__inner{
          padding: 5px 5px;
        }
      }


    }
      .confirmprimary {
        position: absolute;
        border-radius: 10px;
        width: 95%;
        height: 40px;
        bottom: 5px;
        overflow: hidden;
        text-align: center;
        background-color: #00b43c;
        border-radius: 10px;
        left: 3%;
        .pay {
          line-height: 40px;
          text-align: center;
          font-size: 14px;
          font-weight: 700;
          color: #fff;
        }
      }
    }
    
}
</style>



// WEBPACK FOOTER //
// confirm.vue?4fb8fe48